import { components } from "./components/index";
import { events } from "./events/index";

const ContactsSection = {
  components,
  events
};

export { ContactsSection };